export const firstDropdown = {
    id: 'firstDropdown',
    selected: {
        courseName: 'VAAL',
        countryFlagPath: 'sa-flag-icon'
    }
};

export const secondDropdown = {
    id: 'secondDropdown',
    selected: {
        courseName: 'GREYVILLE',
        countryFlagPath: 'sa-flag-icon'
    }
};

export const thirdDropdown = {
    id: 'thirdDropdown',
    selected: {
        courseName: 'VAAL',
        countryFlagPath: 'sa-flag-icon'
    }
};

export const fourthDropdown = {
    id: 'fourthDropdown',
    selected: {
        courseName: 'KEMPTON',
        countryFlagPath: 'uk-flag-icon'
    }
};
